import { Role } from '../api/authApi';

/**
 * Safely extracts the role name from a role that can be either a Role object or a string
 */
export const getRoleName = (role: Role | string | undefined): string => {
  if (!role) return 'Unknown';
  
  if (typeof role === 'string') {
    return role;
  }
  
  if (typeof role === 'object' && role.name) {
    return role.name;
  }
  
  return 'Unknown';
};

/**
 * Checks if a role is a specific role name
 */
export const isRole = (role: Role | string | undefined, roleName: string): boolean => {
  const currentRoleName = getRoleName(role);
  return currentRoleName === roleName;
}; 